"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _basePath = _interopRequireDefault(require("../common/constants/basePath"));

var _EditStoryboard = _interopRequireDefault(require("./EditStoryboard"));

var _ListStoryboards = _interopRequireDefault(require("./ListStoryboards"));

var _default = [{
  component: _EditStoryboard.default,
  path: "".concat(_basePath.default, "/edit/:id")
}, {
  component: _ListStoryboards.default,
  path: "".concat(_basePath.default, "/")
}];
exports.default = _default;